// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  --min-width: 335px;
  --max-height: 400px;
}

.searchbar-grid ion-grid {
  --ion-item-background: #DFDFDF !important;
  background: #DFDFDF !important;
}

ion-list {
  --border-radius: \$searchbar-radius !important;
  --border-radius: \$searchbar-radius;
}

ion-searchbar {
  position: relative;
  --border-radius: \$searchbar-radius !important;
  --box-shadow: \$box-shadow !important;
  --icon-color: var(--searchbar-icon) !important;
  --color: var(--pitch-dark) !important;
}

ion-thumbnail {
  --border-radius: \$searchbar-radius!important;
}

ion-label {
  color: var(--pitch-dark) !important;
}

ion-list.scrollable-list {
  --box-shadow: \$box-shadow;
  overflow-y: scroll;
  height: 18rem;
  background: var(--searchbar-open) !important;
}

ion-item::part(native) {
  background-color: var(--searchbar-open);
}

ion-icon[name*=close-outline] {
  font-size: 1.75rem;
}

.searchbar-counter {
  position: absolute;
  color: var(--link-color);
  left: unset;
  right: 7rem;
  top: 1.4rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  font-size: 1rem;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}
.searchbar-close {
  position: absolute;
}
.searchbar-spacer {
  margin-top: 1rem;
}

@media screen and (max-width: 550px) {
  ion-icon[name*=close-outline] {
    transform: translateY(0.5rem);
  }
}
@media screen and (max-width: 340px) {
  .searchbar-counter {
    transform: translatey(-5px);
  }
}
ion-button.desktop-search-cancel-button {
  max-height: 42px;
  --border-radius: 6px;
  color: #fff;
  background: var(--ion-color-searchbar-cancel);
}

ion-button.ios-search-cancel-button {
  background: var(--ion-color-searchbar-cancel);
  color: #fff;
}
@media screen and (max-width: 550px) {
  ion-button.ios-search-cancel-button {
    transform: translateY(8px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/searchbar/searchbar.component.scss"],"names":[],"mappings":"AAGA;EACI,kBAAA;EACA,mBAAA;AAFJ;;AAIA;EACI,yCAAA;EACA,8BAAA;AADJ;;AAIA;EACI,6CAAA;EACA,kCAAA;AADJ;;AAIA;EACI,kBAAA;EAEA,6CAAA;EACA,oCAAA;EACA,8CAAA;EACA,qCAAA;AAFJ;;AAKA;EACI,4CAAA;AAFJ;;AAKA;EACI,mCAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,4CAAA;AAFJ;;AAKA;EACI,uCAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;;AAKA;EACQ,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFR;AAUA;EACI,kBAAA;AARJ;AAiBA;EACI,gBAAA;AAfJ;;AAkBA;EACI;IACI,6BAAA;EAfN;AACF;AAuBA;EACI;IACI,2BAAA;EArBN;AACF;AA0BA;EACI,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,6CAAA;AAxBJ;;AA4BE;EACE,6CAAA;EACA,WAAA;AAzBJ;AA0BI;EAHF;IAIE,0BAAA;EAvBF;AACF","sourcesContent":["$searchbar-radius: .375rem;\r\n$box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\r\n\r\n* {\r\n    --min-width: 335px;\r\n    --max-height: 400px; \r\n}\r\n.searchbar-grid ion-grid {\r\n    --ion-item-background: #DFDFDF !important;\r\n    background: #DFDFDF !important;\r\n  }\r\n\r\nion-list {\r\n    --border-radius: $searchbar-radius !important;\r\n    --border-radius: $searchbar-radius;\r\n}\r\n\r\nion-searchbar {\r\n    position: relative;\r\n    // --background: #CCCFD2;\r\n    --border-radius: $searchbar-radius !important;\r\n    --box-shadow: $box-shadow !important;\r\n    --icon-color: var(--searchbar-icon) !important;\r\n    --color: var(--pitch-dark) !important;\r\n}\r\n\r\nion-thumbnail {\r\n    --border-radius: $searchbar-radius!important;\r\n}\r\n\r\nion-label {\r\n    color: var(--pitch-dark) !important;\r\n}\r\n\r\nion-list.scrollable-list {\r\n    --box-shadow: $box-shadow;\r\n    overflow-y: scroll;\r\n    height: 18rem;\r\n    background: var(--searchbar-open) !important;\r\n}\r\n\r\nion-item::part(native) {\r\n    background-color: var(--searchbar-open);\r\n}\r\n\r\nion-icon[name*='close-outline'] {\r\n    font-size: 1.75rem;\r\n}\r\n\r\n.searchbar-counter {\r\n        position: absolute;\r\n        color: var(--link-color);\r\n        left: unset;\r\n        right: 7rem;\r\n        top: 1.4rem;\r\n        width: 1.5rem;\r\n        height: 1.5rem;\r\n        border-radius: 50%;\r\n        font-size: 1rem;\r\n        font-weight: bold;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    @media screen and (max-height: 450px) {\r\n    //    top:1.05rem;\r\n    }\r\n    \r\n\r\n}\r\n\r\n.searchbar-close {\r\n    position: absolute;\r\n    // left: unset;\r\n    // right: 1rem;\r\n    // top: 0.5rem;\r\n    @media screen and (max-height: 450px) {\r\n        // top: 1.1rem;\r\n    }\r\n}\r\n\r\n.searchbar-spacer {\r\n    margin-top: 1rem;\r\n}\r\n\r\n@media screen and (max-width: 550px) {\r\n    ion-icon[name*='close-outline'] {\r\n        transform: translateY(0.5rem);\r\n    }\r\n}\r\n@media screen and (max-width: 390px) {\r\n    .searchbar-counter {\r\n        // top: 1.05rem;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 340px) {\r\n    .searchbar-counter {\r\n        transform: translatey(-5px);\r\n    }\r\n}\r\n\r\n\r\n\r\nion-button.desktop-search-cancel-button {\r\n    max-height: 42px;\r\n    --border-radius: 6px;\r\n    color: #fff;\r\n    background: var(--ion-color-searchbar-cancel);\r\n\r\n\r\n  }\r\n  ion-button.ios-search-cancel-button{\r\n    background: var(--ion-color-searchbar-cancel);\r\n    color: #fff;\r\n    @media screen and (max-width: 550px) {\r\n    transform: translateY(8px);\r\n    }\r\n  }\r\n\r\n\r\n\r\n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
